module.exports = __webpack_public_path__ + "static/img/see.58aae52e.svg";